export const WebGl2Settings = {
    FrequentGlErrorChecking: false, // this is useful for debugging but has a major performance impact
    InstanceTracking: false,
}
